export default __webpack_public_path__ + "static/media/Crear evento.5766b332.png";